import React, { useEffect, useState } from 'react';
import { Row, Col, Spinner, Button } from 'react-bootstrap';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_BASE_URL, getBearerToken } from '../../../functions';
import { useAuth } from '../auth/AuthProvider';
import UmrahPackageCard from './UmrahPackageCard';
import BookUmrah from '../../Modals/BookUmrah';

const UmrahPackagesUser = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookUmrahShow, setBookUmrahShow] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        // Use different endpoint based on role
        const endpoint = token.role === 'admin' 
          ? `${API_BASE_URL}/umrah-packages?status=active`
          : `${API_BASE_URL}/umrah-packages-user`;
          
        const response = await axios.get(endpoint, {
          headers: { Authorization: `Bearer ${getBearerToken()}` }
        });
        
        // Handle different response structures - both endpoints return paginated data
        const packagesData = token.role === 'admin' 
          ? response?.data?.data?.data || []
          : response?.data?.data?.data || [];
          
        setPackages(packagesData);
      } catch (error) {
        console.error('Error fetching Umrah packages:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, [token.role]);

  if (loading) {
    return (
      <div className={'mt-3 w-100 text-center'}>
        <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
      </div>
    );
  }

  return (
    <>
      <div className={'main_heading mb-4 d-flex justify-content-between align-items-center'}>
        <div>
          <h4>Available Umrah Packages</h4>
          <p className="text-muted mb-0">Choose from our carefully curated packages for your blessed journey</p>
        </div>
        {token.role === 'admin' && (
          <div>
            <Link to="/dashboard/umrah" className="btn btn-outline-success me-2">
              <i className="fas fa-cog me-1"></i>
              Manage Packages
            </Link>
            <Link to="/dashboard/add-umrah" className="btn btn-success">
              <i className="fas fa-plus me-1"></i>
              Add New Package
            </Link>
          </div>
        )}
      </div>
      
      {packages.length > 0 ? (
        <div>
          {packages.map((pkg) => (
            <UmrahPackageCard 
              key={pkg.id}
              package={pkg} 
              onBook={(bookingData) => setBookUmrahShow(bookingData)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-5">
          <i className="fas fa-kaaba fa-3x text-muted mb-3"></i>
          <h5 className="text-muted">No Umrah packages available at the moment</h5>
          <p className="text-muted">Please check back later for new packages</p>
        </div>
      )}

      {bookUmrahShow && (
        <BookUmrah 
          show={!!bookUmrahShow} 
          setShow={setBookUmrahShow} 
          selectedPackage={bookUmrahShow} 
        />
      )}
    </>
  );
};

export default UmrahPackagesUser;
